import Vue      from 'vue'

import c_teste  from './components/teste.vue';

Vue.component('c-teste',          c_teste);

